import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { useRootStore } from 'stores/RootStore'
import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import { Action, ActionProps } from './Action'
import { SEOAnalysis as SEOAnalysisIcon } from 'blaze-ui/icons/36'
import cx from 'classnames'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { BarGroup3 } from 'blaze-ui/icons/24'

export const SEOAnalysis = observer(function SEOAnalysis({ className, ...props }: ActionProps) {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { rightRailPanelStore } = useRootStore()
  const docStore = useDocStore()

  const handleClick = () => {
    docStore?.rightRailStore.setActiveTab(undefined)
    rightRailPanelStore.show('seo')
    trackEventInHeap(HeapEventType.SeoAnalysis, { action: 'seo-analysis' })
  }

  return (
    <Action
      {...props}
      className={cx(className, 'blog-post-output-tour-2')}
      icon={isSystemRedesignEnabled ? BarGroup3 : SEOAnalysisIcon}
      onPress={handleClick}
    />
  )
})
